module.exports = __webpack_public_path__ + "static/media/vegitables_56.be379cd4.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_56.csv
// module id = 642
// module chunks = 0